var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"slider-com"},_vm._l((_vm.slider),function(item){return _c('div',{key:item.sid,class:_vm.currentSid==item.sid?'slider-com-sub check':'slider-com-sub',on:{"click":function($event){return _vm.change(item.sid)}}},[_vm._v(_vm._s(item.name))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }